import React from "react";
import styled from "styled-components";

const StyledDeadlineBar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${({ theme }) => theme.space[2]};
  background-color: ${({ theme }) => theme.colors.white};
  font-size: 1.8rem;

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    border-radius: ${({ theme }) => theme.radii[2]};
`;

const Heading = styled.h3`
  margin-top: 0;
  margin-bottom: 0;
  line-height: 1;
  color: ${({ theme }) => theme.colors.black};
  font-size: inherit;
  font-weight: normal;
`;

const Deadline = styled.time`
  margin-left: 0.4rem;
  line-height: 1;
  color: ${({ theme }) => theme.colors.primary};
  font-weight: bold;
`;

interface IProps {
  deadlineISO: string;
  deadlineLocal: string;
  headingText: string;
}

const DeadlineBar: React.FC<IProps> = ({
  deadlineISO,
  deadlineLocal,
  headingText,
}) => (
  <StyledDeadlineBar>
    <Heading>{headingText}:</Heading>
    <span>&nbsp;</span>
    <Deadline dateTime={deadlineISO}>{deadlineLocal}</Deadline>
  </StyledDeadlineBar>
);

export default DeadlineBar;
